import classNames from "classnames";

type NavItemProps = {
	children: React.ReactNode;
	className?: string;
};

const NavItem = ({ children, className }: NavItemProps) => {
	return <li className={classNames("nav__item", className)}>{children}</li>;
};

export default NavItem;
